export default "__VITE_ASSET__LclcACgf__"